import { URL_SERVICE, URL_TRANSVERSAL } from "../constants/api-constants";
import { axiosInstance } from './axios-instance';

class TransversalServices {
    // brings the user data
    static getInfoUser(config) {
        return axiosInstance.get(URL_SERVICE + "/account/api/v1/get-info-user", config).then(resp => resp.data)
    }
    // brings user´s points
    static getUserPoints(config) {
        return axiosInstance.get(URL_SERVICE + "/account/api/v1/points-user", config).then(resp => resp.data)
    }

    static sendKey(payload, config) {
        return axiosInstance.post(URL_SERVICE + "/accumulation/api/v1/key", payload, config).then(resp => resp.data)
    }
    static cookiePolicy(payload, config) {
        return axiosInstance.post(URL_TRANSVERSAL + "/transversal/api/v1/cookie-policy", payload, config).then(resp => resp.data)
    }

     // brings user´s saved articles
     static getAllArticle(config) {
        return axiosInstance.get(URL_SERVICE + "/rating/api/v1/all-article", config).then(resp => resp.data)
    }

     // update habeas data checks
     static updateHabeasTerms(payload, config) {
        return axiosInstance.put(URL_SERVICE + "/account/api/v1/update-user-tyc", payload, config).then(resp => resp.data)
    }

     //Sends an OTP
     static sendOTP(payload, config) {
        return axiosInstance.post(URL_SERVICE + "/otp/api/v1/otp/", payload, config).then(resp => resp.data)
    }

     //register competition participation
     static postCompetition(payload, config) {
        return axiosInstance.post(URL_SERVICE + "/competition/api/v1/competition-participation", payload, config).then(resp => resp.data)
    }

  //get competition participation
  static getUserParticipationCampaign({ competitionId, config }) {
    return axiosInstance
      .get(
        `${URL_SERVICE}/competition/api/v1/get-participation-concourse?concourseId=${competitionId}`,
        config
      )
      .then(resp => resp.data)
  }

    //allows to uptade user´s information
    static uptadeUserInfo(payload, config) {
        return axiosInstance.put(URL_SERVICE + "/account/api/v1/update-user-info", payload, config).then(resp => resp.data)
    }
}

export default TransversalServices;